import Api from '@/services/Api'

export default {
  sugerenciasDireccion(datos) {
    return Api().post('search-direction/', datos)
  },
  searchGeolocalizacion(params) {
    return Api().get('search-geolocalizacion', { params })
  },
  searchEmpleado(numeroEmpleado) {
    return Api().get('search-empleado', {
      params: {
        numero_empleado: numeroEmpleado,
      },
    })
  },
}
